import { networks } from '../config/settings';

/**
 * Normalize any chainId shape (hex string, decimal string, number, bigint)
 * to a numeric chain ID for reliable comparison.
 */
export function parseChainId(chainId) {
  if (chainId === undefined || chainId === null) return null;
  if (typeof chainId === 'bigint') return Number(chainId);
  const s = String(chainId).trim();
  if (!s) return null;
  if (s.startsWith('0x') || s.startsWith('0X')) return parseInt(s, 16);
  return parseInt(s, 10);
}

export function toHexChainId(chainId) {
  const id = parseChainId(chainId);
  if (!Number.isFinite(id)) return null;
  return `0x${id.toString(16)}`;
}

/**
 * Find the configured network entry matching a wallet/RPC chain ID.
 * Returns [networkKey, networkConfig] or null.
 */
export function findNetworkByChainId(chainId) {
  const id = parseChainId(chainId);
  if (!Number.isFinite(id)) return null;

  for (const [key, net] of Object.entries(networks)) {
    if (parseChainId(net.chainId) === id) return [key, net];
    if (net.altChainId && parseChainId(net.altChainId) === id) return [key, net];
  }
  return null;
}
